import { render, staticRenderFns } from "./manual_invoice_form.vue?vue&type=template&id=2b5e1c74&"
import script from "./manual_invoice_form.vue?vue&type=script&lang=js&"
export * from "./manual_invoice_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports